import '../App.css';
import React from 'react';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import awsexports from '../aws-exports';
import { ThemeProvider } from '@aws-amplify/ui-react';
import FaceLiveness from '../Components/FaceLiveness';
import ReferenceImage from '../Components/ReferenceImage';
import {
  View,
  Flex,
} from '@aws-amplify/ui-react';
import { v4 } from 'uuid';

Amplify.configure(awsexports);

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const assessmentUrl = urlParams.get('assessmentUrl');
const eventId = urlParams.get('eventId');
const token = v4().substring(0,16);
localStorage.setItem('eventId', eventId);

export function Liveness() {

  const [faceLivenessAnalysis, setFaceLivenessAnalysis] = React.useState(null)

  const getFaceLivenessAnalysis = (faceLivenessAnalysis) => {
    if (faceLivenessAnalysis !== null) {
      setFaceLivenessAnalysis(faceLivenessAnalysis)
    }
  }

  const tryAgain = (eventId) =>{
    setFaceLivenessAnalysis(null);
    window.location.reload(false);
  }

  return (
    <ThemeProvider>
    <Flex
      direction="row"
      justifyContent="center"
      alignItems="center"
      alignContent="flex-start"
      wrap="nowrap"
      gap="1rem"
    >
      <View
        as="div"
        maxHeight="600px"
        height="600px"
        width="740px"
        maxWidth="740px"
      >
        {faceLivenessAnalysis && faceLivenessAnalysis.Confidence ? (
          <ReferenceImage faceLivenessAnalysis={faceLivenessAnalysis} tryAgain={tryAgain} eventId={eventId} token={token} assessmentUrl={assessmentUrl}></ReferenceImage>
        ) :
          (<FaceLiveness faceLivenessAnalysis={getFaceLivenessAnalysis} tryAgain={tryAgain} eventId={eventId} token={token} />)}

      </View>
    </Flex>
  </ThemeProvider>
);
}

export default Liveness;
